module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/Badges/Payments/Visa-e28f4cb5c001d78b00ae7cdd2fd6e3d2.svg";